/* MOJITO Concierge Bubble — site-wide AI shopping assistant.
   Additive: loaded by snippets/mojito-bubble.liquid; remove that render line
   in layout/theme.liquid to disable. Talks to the mojito-returns-api worker
   (/api/bubble-session + /api/bubble-chat). Anonymous visitors only — order
   questions are routed to the returns portal page. */
(function () {
  'use strict';

  var script = document.currentScript || document.querySelector('script[data-mojito-bubble]');
  if (!script) return;
  var API = script.getAttribute('data-api') || '';
  if (!API) return;

  // The returns portal page has its own concierge — never show both.
  if (window.location.pathname.indexOf('/pages/returns-exchanges') !== -1) return;

  var isES = (script.getAttribute('data-locale') || document.documentElement.lang || 'en')
    .toLowerCase().indexOf('es') === 0;

  var T = isES ? {
    title: 'Mojito Concierge',
    teaser: '👋 ¿Te ayudo a encontrar la prenda perfecta?',
    greeting: '¡Hola! Puedo ayudarte a encontrar la prenda ideal o responder tus preguntas. ¿Qué buscas hoy?',
    chips: ['Ayúdame a elegir un look', 'Envíos y entregas', 'Devoluciones y cambios'],
    placeholder: 'Escribe tu mensaje…',
    send: 'Enviar',
    view: 'Ver',
    error: 'Algo salió mal. Inténtalo de nuevo.',
    expired: 'La sesión expiró. Inténtalo de nuevo.',
    open: 'Abrir chat de ayuda',
    close: 'Cerrar chat',
    hide: 'Ocultar el chat',
    show: 'Mostrar el chat',
    back: 'Atrás',
    homeHi: '¡Hola!',
    homeSub: '¿En qué te ayudamos hoy?',
    seeChats: 'Ver todos los chats',
    allChats: 'Todos los chats',
    newChat: 'Nuevo chat',
    privacy: 'Esta lista de chats se borra al cerrar la pestaña. Los chats son anónimos y se guardan para mejorar nuestro servicio.',
    track: 'Rastrear un paquete',
    justNow: 'Ahora',
    minAgo: ' min',
    hrAgo: ' h',
    dayAgo: ' d',
    deleteChat: 'Eliminar chat',
    deleteConfirm: '¿Eliminar?',
    prevCards: 'Sugerencias de productos',
    prevTrack: 'Seguimiento de paquete',
    trackIntro: 'Con gusto te ayudo a ubicar tu paquete. Elige lo que te resulte más fácil:',
    trackHere: 'Rastrear aquí',
    trackHereSub: 'Número de pedido y correo. Respuesta en segundos.',
    trackHereSubIn: 'Número de pedido y correo, sin salir del chat.',
    acctOut: 'Ver todos mis pedidos',
    acctOutSub: 'Inicia sesión con un código de un solo uso. Sin contraseña.',
    acctIn: 'Abrir mis pedidos',
    acctInSub: 'Ya iniciaste sesión. Un toque y ves todos tus pedidos.',
    orderHint: 'Tu número de pedido está en el correo de confirmación.',
    somethingElse: 'Otra cosa',
    formIntro: 'Escribe tu número de pedido y el correo que usaste al comprar.',
    fOrder: 'Número de pedido',
    fOrderPh: '#MC12345',
    fEmail: 'Correo usado al comprar',
    fEmailPh: 'tu@correo.com',
    fZip: 'Código postal de envío',
    fZipPh: '90210',
    useZip: 'Usar código postal',
    useEmail: 'Usar correo',
    find: 'Buscar mi paquete',
    finding: 'Buscando…',
    tryAgain: 'Intentar de nuevo',
    formNote: 'Solo mostramos el estado de entrega. Tu correo no se guarda.',
    notFoundEmail: 'No encontramos un pedido con ese número y correo. Revisa tu correo de confirmación e inténtalo de nuevo.',
    notFoundZip: 'No encontramos un pedido con ese número y código postal. Revisa tu correo de confirmación e inténtalo de nuevo.',
    tooMany: 'Demasiadas búsquedas. Espera un minuto e inténtalo de nuevo.',
    acctInstead: 'Ver todos mis pedidos',
    amazon: 'Parece un número de pedido de Amazon. Los pedidos de Amazon se rastrean en tu cuenta de Amazon.',
    amazonLink: 'Abrir pedidos de Amazon',
    found: 'Lo encontré. Así va el pedido {o}:',
    pkgOf: 'Paquete {n} de {t}',
    items: '{n} artículos',
    item1: '1 artículo',
    steps: ['Pedido', 'Enviado', 'En reparto', 'Entregado'],
    stepProblem: 'Problema',
    orderedOn: 'Pedido el {d}',
    stPreparing: 'Preparando tu pedido',
    stPreparingX: 'Te enviaremos un correo con el rastreo en cuanto salga.',
    stShipped: 'Enviado',
    stShippedS: 'Enviado el {d}',
    stNoTracking: 'Este envío no tiene enlace de rastreo',
    stNoTrackingX: 'Si no llega en una semana, avísame.',
    stTransit: 'En camino',
    stOut: 'En reparto hoy',
    lastUpdate: 'Última actualización {t}',
    stDelivered: 'Entregado el {d}',
    stDeliveredX: '¿No lo ves? Pregunta a tus vecinos o en la recepción, o avísame y lo paso a atención al cliente.',
    stAttempted: 'Intento de entrega',
    stAttemptedS: 'La paquetería volverá a intentarlo',
    stPickup: 'Listo para recoger',
    stPickupS: 'Esperando en el punto de recogida',
    stProblem: 'Problema con la entrega',
    stProblemS: '{c} reportó un problema',
    stProblemX: 'Lo resolvemos. Escríbenos a customer.service@mojitocollection.com o toca Contáctanos.',
    stCancelled: 'Este pedido fue cancelado',
    stCancelledX: '¿Dudas? Escríbenos a customer.service@mojitocollection.com.',
    carrier: 'La paquetería',
    arrives: 'Llega el {d}',
    trackingLbl: 'Rastreo {c}',
    trackingLblGen: 'Número de rastreo',
    trackOn: 'Rastrear en {c}',
    trackPkg: 'Rastrear paquete',
    checked: 'Consultado {t}',
    justNowLower: 'ahora mismo',
    agoMin: 'hace {n} min',
    agoHr: 'hace {n} h',
    refresh: 'Actualizar',
    trackAnother: 'Rastrear otro pedido',
    returnEx: 'Devolución o cambio',
    problem: 'Problema con la entrega',
    notDelivered: 'No me llegó',
    contact: 'Contáctanos',
    problemReply: 'Lo sentimos. Escríbenos a customer.service@mojitocollection.com con tu número de pedido y lo resolvemos enseguida.',
    emailUs: 'Escribir a atención al cliente'
  } : {
    title: 'Mojito Concierge',
    teaser: '👋 Need help finding the right piece?',
    greeting: 'Hi! I can help you find the right piece or answer questions about sizing, fabric, and shipping. What brings you in today?',
    chips: ['Help me find something', 'Shipping & delivery', 'Returns & exchanges'],
    placeholder: 'Type your message…',
    send: 'Send',
    view: 'View',
    error: 'Something went wrong. Please try again.',
    expired: 'Session expired. Please try again.',
    open: 'Open help chat',
    close: 'Close chat',
    hide: 'Hide chat',
    show: 'Show chat',
    back: 'Back',
    homeHi: 'Hi there.',
    homeSub: 'What can we do for you today?',
    seeChats: 'See all chats',
    allChats: 'All chats',
    newChat: 'Start new chat',
    privacy: 'This chat list clears when you close the tab. Chats are anonymous and kept to improve our service.',
    track: 'Track a package',
    justNow: 'Just now',
    minAgo: ' min',
    hrAgo: ' hr',
    dayAgo: ' d',
    deleteChat: 'Delete chat',
    deleteConfirm: 'Delete?',
    prevCards: 'Product suggestions',
    prevTrack: 'Package tracking',
    trackIntro: 'Happy to help you find your package. Pick whichever is easier:',
    trackHere: 'Track it here',
    trackHereSub: 'Order number and email. Answer in seconds.',
    trackHereSubIn: 'Order number and email, without leaving the chat.',
    acctOut: 'See all my orders',
    acctOutSub: 'Sign in with a one-time code. No password.',
    acctIn: 'Open my orders',
    acctInSub: "You're signed in. One tap to every order.",
    orderHint: 'Your order number is in your confirmation email.',
    somethingElse: 'Something else',
    formIntro: 'Enter your order number and the email you used at checkout.',
    fOrder: 'Order number',
    fOrderPh: '#MC12345',
    fEmail: 'Email used at checkout',
    fEmailPh: 'you@email.com',
    fZip: 'Shipping ZIP code',
    fZipPh: '90210',
    useZip: 'Use ZIP instead',
    useEmail: 'Use email instead',
    find: 'Find my package',
    finding: 'Looking…',
    tryAgain: 'Try again',
    formNote: "We only show delivery status. Your email isn't saved.",
    notFoundEmail: "We couldn't find an order with that number and email. Check your confirmation email and try again.",
    notFoundZip: "We couldn't find an order with that number and ZIP code. Check your confirmation email and try again.",
    tooMany: 'Too many lookups. Give it a minute and try again.',
    acctInstead: 'See all my orders instead',
    amazon: 'That looks like an Amazon order number. Amazon orders are tracked in your Amazon account.',
    amazonLink: 'Open Amazon orders',
    found: "Found it. Here's where order {o} is:",
    pkgOf: 'Package {n} of {t}',
    items: '{n} items',
    item1: '1 item',
    steps: ['Ordered', 'Shipped', 'Out for delivery', 'Delivered'],
    stepProblem: 'Problem',
    orderedOn: 'Ordered {d}',
    stPreparing: 'Getting your order ready',
    stPreparingX: "You'll get an email with tracking the moment it ships.",
    stShipped: 'Shipped',
    stShippedS: 'Shipped {d}',
    stNoTracking: 'No tracking link for this shipment',
    stNoTrackingX: "If it hasn't arrived within a week, tell me.",
    stTransit: 'On the way',
    stOut: 'Out for delivery today',
    lastUpdate: 'Last update {t}',
    stDelivered: 'Delivered {d}',
    stDeliveredX: "Not there? Check with neighbors or your mailroom, or tell me and I'll get customer service on it.",
    stAttempted: 'Delivery attempted',
    stAttemptedS: 'The carrier will try again',
    stPickup: 'Ready for pickup',
    stPickupS: 'Waiting at the pickup point',
    stProblem: 'Delivery problem',
    stProblemS: '{c} reported an issue',
    stProblemX: "We'll sort it out. Email customer.service@mojitocollection.com or tap Contact us.",
    stCancelled: 'This order was cancelled',
    stCancelledX: 'Questions? Email customer.service@mojitocollection.com.',
    carrier: 'The carrier',
    arrives: 'Arrives {d}',
    trackingLbl: '{c} tracking',
    trackingLblGen: 'Tracking number',
    trackOn: 'Track on {c}',
    trackPkg: 'Track package',
    checked: 'Checked {t}',
    justNowLower: 'just now',
    agoMin: '{n} min ago',
    agoHr: '{n} hr ago',
    refresh: 'Refresh',
    trackAnother: 'Track another order',
    returnEx: 'Return or exchange',
    problem: 'Delivery problem',
    notDelivered: "It wasn't delivered",
    contact: 'Contact us',
    problemReply: "Sorry about that. Email customer.service@mojitocollection.com with your order number and we'll sort it out right away.",
    emailUs: 'Email customer service'
  };

  var state = {
    token: null,
    tokenExp: 0,
    sid: '',           // bubble session id (UUID) — the attribution join key
    history: [],       // {role, content} — cleaned text only
    log: [],           // render transcript: {t:'user'|'assistant',x} | {t:'cards',c:[...]}
    open: false,
    busy: false,
    turnProducts: [],  // card payloads for THIS turn's [[CARD:n]] markers
    chats: [],         // this tab-session's conversations, newest first
    chat: null,        // the active chat object, or null while the transcript is a draft
    view: 'home',      // 'home' | 'list' | 'chat'
    prevView: 'home',
    trackPref: false,  // tracked a package in-chat this session → Home skips the choice step
    lastOrder: '',     // order number to prefill (never the email)
    trackCreds: null   // {order, email|zip} kept in MEMORY only for Refresh — never stored
  };

  // ---------- chats: model + persistence ----------
  // One tab-session holds up to MAX_CHATS conversations, each capped at
  // MAX_LOG transcript entries, in sessionStorage — the scope the single
  // transcript always had: carries across page navigations and refreshes in
  // this tab, gone when the tab closes, never sent anywhere. A chat exists
  // only once something was logged into it (the first customer message, or
  // a Track a package step); the greeting alone is a draft that never lists,
  // so "Start new chat" can be tapped freely. state.log is ALWAYS the array
  // being painted: the active chat's log, or the draft's.
  var STORE_KEY = 'mjbChats';
  var LEGACY_KEY = 'mjbChat';
  var MAX_CHATS = 10;
  var MAX_LOG = 40;

  function saveChat() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        v: 1,
        view: state.view,
        active: state.chat ? state.chat.id : null,
        open: state.open,
        trackPref: !!state.trackPref,
        lastOrder: state.lastOrder || '',
        chats: state.chats.map(function (c) {
          return { id: c.id, created: c.created, updated: c.updated, title: c.title, log: c.log.slice(-MAX_LOG) };
        })
      }));
    } catch (e) { /* storage unavailable — chats stay per-page */ }
  }
  function restoreChat() {
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    if (!data) data = migrateLegacy();
    if (!data) return;
    state.chats = [];
    (Array.isArray(data.chats) ? data.chats : []).forEach(function (c) {
      if (!c || typeof c.id !== 'string' || !Array.isArray(c.log) || !c.log.length) return;
      if (state.chats.length >= MAX_CHATS) return;
      state.chats.push({
        id: c.id,
        created: +c.created || Date.now(),
        updated: +c.updated || Date.now(),
        title: cleanTitle(c.title),
        log: c.log.slice(-MAX_LOG)
      });
    });
    state.trackPref = !!data.trackPref;
    state.lastOrder = typeof data.lastOrder === 'string' ? data.lastOrder.slice(0, 20) : '';
    var active = typeof data.active === 'string' ? chatById(data.active) : null;
    if (active) activateChat(active, true);
    state.view = data.view === 'list' ? 'list' : (data.view === 'chat' && active ? 'chat' : 'home');
    if (data.open) openPanel(true);
  }
  // A visitor mid-conversation under the old single-transcript key when this
  // ships keeps that conversation as their first chat.
  function migrateLegacy() {
    var old = null;
    try { old = JSON.parse(sessionStorage.getItem(LEGACY_KEY) || 'null'); } catch (e) {}
    try { sessionStorage.removeItem(LEGACY_KEY); } catch (e) {}
    if (!old || !Array.isArray(old.log) || !old.log.length) return null;
    var first = '';
    for (var i = 0; i < old.log.length; i++) {
      var e = old.log[i];
      if (e && e.t === 'user' && typeof e.x === 'string' && e.x) { first = e.x; break; }
    }
    if (!first) return null;
    var id = newId();
    return {
      v: 1, view: old.open ? 'chat' : 'home', active: id, open: !!old.open,
      chats: [{ id: id, created: Date.now(), updated: Date.now(), title: first, log: old.log }]
    };
  }
  function newId() {
    return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }
  function chatById(id) {
    for (var i = 0; i < state.chats.length; i++) if (state.chats[i].id === id) return state.chats[i];
    return null;
  }
  function chatForLog(log) {
    for (var i = 0; i < state.chats.length; i++) if (state.chats[i].log === log) return state.chats[i];
    return null;
  }
  function cleanTitle(s) {
    s = String(s || '').replace(/\s+/g, ' ').trim();
    if (!s) s = T.title;
    return s.length > 60 ? s.slice(0, 57) + '…' : s;
  }
  // Promote the draft transcript into a listed chat (idempotent).
  function ensureChat(title) {
    if (state.chat) return state.chat;
    var chat = { id: newId(), created: Date.now(), updated: Date.now(), title: cleanTitle(title), log: state.log };
    state.chats.unshift(chat);
    while (state.chats.length > MAX_CHATS) state.chats.pop();
    state.chat = chat;
    track('chat_new', {});
    saveChat();
    return chat;
  }
  function logPushTo(log, entry) {
    log.push(entry);
    if (log.length > MAX_LOG) log.splice(0, log.length - MAX_LOG);
    var chat = chatForLog(log);
    if (chat) chat.updated = Date.now();
    saveChat();
  }
  function logPush(entry) { logPushTo(state.log, entry); }
  // Remove a transient flow entry (choice cards, the form) from the log and
  // the transcript once the customer has moved past it.
  function dropEntry(entry, node) {
    var i = state.log.indexOf(entry);
    if (i !== -1) state.log.splice(i, 1);
    if (node && node.parentNode) node.parentNode.removeChild(node);
    saveChat();
  }
  function historyFromLog(log) {
    return log
      .filter(function (e) { return e && (e.t === 'user' || e.t === 'assistant' || e.t === 'ctx') && typeof e.x === 'string' && e.x; })
      .map(function (e) { return { role: e.t === 'user' ? 'user' : 'assistant', content: e.x }; })
      .slice(-20);
  }
  function activateChat(chat, silent) {
    state.chat = chat;
    state.log = chat.log;
    state.history = historyFromLog(chat.log);
    renderChat();
    if (!silent) track('chat_resume', {});
  }
  function startDraft() {
    state.chat = null;
    state.log = [];
    state.history = [];
    clearMessages();
    addBubble('assistant', T.greeting);
    renderChips();
  }
  function clearMessages() {
    while (messagesEl.firstChild) messagesEl.removeChild(messagesEl.firstChild);
  }
  // Paint state.log into the transcript.
  function renderChat() {
    clearMessages();
    var log = state.log;
    var last = null;
    log.forEach(function (entry) {
      if (!entry) return;
      if (entry.t !== 'ctx') last = entry;
      if ((entry.t === 'user' || entry.t === 'assistant') && typeof entry.x === 'string' && entry.x) addBubble(entry.t, entry.x, true);
      else if (entry.t === 'cards' && Array.isArray(entry.c)) renderCardRow(entry.c);
      else if (entry.t === 'track_choice') renderTrackChoice(entry);
      else if (entry.t === 'track_form') renderTrackForm(entry, !!entry.a);
      else if (entry.t === 'track_result' && entry.r) renderTrackResult(entry);
      // 'ctx' entries feed the model only
    });
    // Never got past the greeting — offer the starter chips again.
    if (log.length === 1 && log[0] && log[0].t === 'assistant') renderChips();
    else if (last && last.t === 'track_result') renderTrackChips(last);
    scrollDown();
  }

  // ---------- session token ----------
  function loadStoredToken() {
    try {
      var raw = sessionStorage.getItem('mjbToken');
      if (!raw) return;
      var d = JSON.parse(raw);
      if (d && d.token && d.exp && d.exp - Date.now() > 60000) {
        state.token = d.token;
        state.tokenExp = d.exp;
        if (typeof d.sid === 'string') state.sid = d.sid;
      }
    } catch (e) { /* storage unavailable — mint per page */ }
  }
  // ---------- Turnstile (bot check on session mint) ----------
  // Active only when the snippet carries data-turnstile-sitekey AND the
  // worker has TURNSTILE_SECRET set (either alone is a safe no-op).
  // Invisible mode: no UI ever appears. api.js loads lazily on the first
  // mint, so visitors who never engage the chat load nothing extra.
  var TS_KEY = script.getAttribute('data-turnstile-sitekey') || '';
  var tsWidgetId = null;
  var tsScriptPromise = null;
  var tsResolve = null;
  var tsInflight = null;

  function tsFire(tok) {
    var r = tsResolve;
    tsResolve = null;
    if (r) r(tok || '');
  }
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(true);
    if (tsScriptPromise) return tsScriptPromise;
    tsScriptPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { resolve(true); };
      s.onerror = function () {
        // Don't cache a transient load failure for the page lifetime — a
        // later mint should retry the load (harmless when truly blocked).
        tsScriptPromise = null;
        try { if (s.parentNode) s.parentNode.removeChild(s); } catch (e) {}
        resolve(false);
      };
      document.head.appendChild(s);
    });
    return tsScriptPromise;
  }
  function getTurnstileToken() {
    if (!TS_KEY) return Promise.resolve('');
    if (tsInflight) return tsInflight;
    tsInflight = new Promise(function (resolve) {
      var settled = false;
      // The timer bounds the WHOLE chain (script load + challenge) — a
      // blackholed api.js request must not hang the chat beyond 15s.
      var timer = setTimeout(function () {
        if (!settled) { settled = true; tsResolve = null; resolve(''); }
      }, 15000);
      var finish = function (tok) {
        if (!settled) { settled = true; clearTimeout(timer); resolve(tok || ''); }
      };
      loadTurnstile().then(function (ok) {
        if (settled) return;
        if (!ok || !window.turnstile) { finish(''); return; }
        tsResolve = finish;
        try {
          if (tsWidgetId === null) {
            var host = document.createElement('div');
            host.className = 'mjb-turnstile';
            (root || document.body).appendChild(host);
            // Callbacks are fixed at render time; turnstile.reset() re-runs
            // the challenge and fires the SAME callback with a fresh token
            // (tokens are single-use, so every mint needs its own).
            tsWidgetId = window.turnstile.render(host, {
              sitekey: TS_KEY,
              callback: function (tok) { tsFire(tok); },
              'error-callback': function () { tsFire(''); },
              'unsupported-callback': function () { tsFire(''); }
            });
            if (tsWidgetId === null || tsWidgetId === undefined) { tsWidgetId = null; tsFire(''); }
          } else {
            window.turnstile.reset(tsWidgetId);
          }
        } catch (e) { tsFire(''); }
      });
    }).then(function (tok) { tsInflight = null; return tok; });
    return tsInflight;
  }

  // One mint at a time: concurrent callers (panel-open pre-warm + a fast
  // first message) must share ONE request — Turnstile tokens are single-use,
  // so two mints posting the same token would 403 the second one.
  var mintInflight = null;
  function mintToken() {
    if (mintInflight) return mintInflight;
    mintInflight = getTurnstileToken().then(function (tsTok) {
      return fetch(API + '/api/bubble-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tsTok ? { turnstileToken: tsTok } : {})
      });
    }).then(function (res) { return res.json(); }).then(function (d) {
      if (d && d.success && d.token) {
        var prevSid = state.sid;
        state.token = d.token;
        state.tokenExp = d.exp || (Date.now() + 3600000);
        state.sid = (typeof d.sid === 'string' && d.sid) ? d.sid : '';
        try { sessionStorage.setItem('mjbToken', JSON.stringify({ token: d.token, exp: state.tokenExp, sid: state.sid })); } catch (e) {}
        // Mid-session re-mint rotates the sid (2h TTL). Emit a linking event
        // so funnel reporting can coalesce the sid chain instead of seeing an
        // orphan conversion under the new sid and a dead session on the old.
        if (prevSid && state.sid && prevSid !== state.sid) {
          track('sid_rotated', { old: prevSid });
        }
        return true;
      }
      return false;
    }).catch(function () { return false; }).then(function (ok) {
      mintInflight = null;
      return ok;
    });
    return mintInflight;
  }
  function ensureToken() {
    if (state.token && state.tokenExp - Date.now() > 60000) return Promise.resolve(true);
    return mintToken();
  }

  // ---------- attribution + funnel telemetry ----------
  // Layer 1 (order-level): once a visitor ENGAGES the chat, their cart gets a
  // `_mjb_sid` attribute (the bubble session UUID — never the bearer token).
  // Shopify copies cart attributes onto the order at checkout; the admin cron
  // sweep then tags matched orders `chat-bubble` and joins revenue to chat
  // sessions in D1.
  // Layer 2 (line-level): clicking a recommendation card writes the SAME
  // sessionStorage marker the theme's other rec surfaces use
  // (mojito_rec_click_<handle>, source 'chat-bubble') and tags the card URL
  // with ?mjb=1 so open-in-new-tab survives; on the PDP the marker becomes a
  // hidden `properties[_rec_source]` input in the main product form — the
  // exact mechanism of mojito-cart-upsell.js / mojito-recommended-top, so
  // every rec source funnels through ONE property (the marker itself is
  // last-write-wins across surfaces — last touch gets line credit, matching
  // the existing surfaces' semantics; "first wins" only applies to an input
  // already injected into an open PDP form). Line properties also ride along
  // on Buy It Now, which skips the cart and therefore its attributes.
  // Telemetry: fire-and-forget beacons to /api/bubble-event (token-gated,
  // fail-open server-side). Nothing here may ever break the chat or the
  // theme — every path is wrapped and silent.
  var REC_KEY_PREFIX = 'mojito_rec_click_'; // shared with the other rec receivers
  var REC_SOURCE = 'chat-bubble';
  var REC_MAX_AGE_MS = 60 * 60 * 1000;      // 1h, matching the existing receivers

  function getSid() {
    if (state.sid) return state.sid;
    if (!state.token) return '';
    // Fallback for tokens minted before the worker returned sid separately:
    // the token body is b64url JSON {b: sid, exp}.
    try {
      var body = state.token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
      while (body.length % 4) body += '=';
      var payload = JSON.parse(atob(body));
      if (payload && typeof payload.b === 'string' && payload.b) {
        state.sid = payload.b;
      }
    } catch (e) { /* opaque token — attribution quietly off */ }
    return state.sid;
  }

  var trackCount = 0;
  var engagedSentToken = null; // page-local: token the 'engaged' beacon rode on
  function track(type, data) {
    try {
      if (!state.token || trackCount >= 60) return; // page-level safety cap
      trackCount++;
      var body = JSON.stringify({ token: state.token, events: [{ t: type, d: data || {} }] });
      // sendBeacon with a string body = a text/plain "simple" request (no
      // CORS preflight) that survives the navigation a card click starts.
      if (navigator.sendBeacon && navigator.sendBeacon(API + '/api/bubble-event', body)) return;
      fetch(API + '/api/bubble-event', { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) { /* telemetry must never break the chat */ }
  }

  var cartAttrSid = '';
  function assertCartAttribute() {
    var sid = getSid();
    if (!sid || cartAttrSid === sid) return;
    cartAttrSid = sid; // optimistic per-page dedupe; reset on failure
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: { _mjb_sid: sid } })
      }).then(function (res) {
        if (!res.ok) cartAttrSid = '';
      }).catch(function () { cartAttrSid = ''; });
    } catch (e) { cartAttrSid = ''; }
  }

  function markEngaged() {
    var done = false;
    try { done = !!sessionStorage.getItem('mjbEngaged'); } catch (e) {}
    if (!done) {
      try { sessionStorage.setItem('mjbEngaged', '1'); } catch (e) {}
      engagedSentToken = state.token;
      track('engaged', { p: String(window.location.pathname).slice(0, 120) });
    }
    // Re-assert at every engagement point: a session can outlive the cart it
    // first stamped (checkout completes → fresh cart), and the write is
    // deduped per page + sid anyway.
    assertCartAttribute();
  }

  function handleFromUrl(u) {
    var m = String(u || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  // PDP receiver: turn a card click (sessionStorage marker or ?mjb=1 param)
  // into the hidden line-item property on the main add-to-cart form.
  function injectChatAttribution(key, handle) {
    var raw = null;
    try { raw = sessionStorage.getItem(key); } catch (e) { return; }
    if (!raw) return;
    var data = null;
    try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || data.source !== REC_SOURCE) return; // other sources belong to their own receivers
    if (Date.now() - (data.ts || 0) > REC_MAX_AGE_MS) {
      try { sessionStorage.removeItem(key); } catch (e) {}
      return;
    }
    var forms = document.querySelectorAll('form[action*="/cart/add"][data-product-form]:not([data-quickbuy-form])');
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="properties[_rec_source]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_rec_source]';
        input.value = REC_SOURCE;
        form.appendChild(input);
      }
      // First-wins across rec surfaces (same convention as the other
      // receivers): if another source already claimed this add, the line
      // isn't chat-attributed — and gets no ATC event either.
      if (input.value !== REC_SOURCE) return;
      // Arm the form for the document-level capture listener below (a
      // per-form listener would run AFTER the theme's own submit handler,
      // which synchronously disables the button for its loading state — the
      // disabled guard would then swallow every legitimate add).
      form.dataset.mjbAtcKey = key;
      form.dataset.mjbAtcHandle = handle;
    });
    bindAtcCapture();
  }

  // ONE capture-phase submit listener on document: capture on an ancestor
  // runs BEFORE any listener on the form itself, so the button state we
  // check is the PRE-submit state (the theme's handler hasn't yet applied
  // its is-loading disable). Mirrors the theme's knowable-at-submit no-op
  // branches: a genuinely disabled button or the sold-out notification
  // popup adds nothing, so those submits consume no marker and count no
  // atc. A failed /cart/add AFTER this point still counts — 'atc' means
  // "attributed add attempted", which is the documented semantics.
  var atcCaptureBound = false;
  function bindAtcCapture() {
    if (atcCaptureBound) return;
    atcCaptureBound = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.dataset || !form.dataset.mjbAtcKey) return;
      var btn = form.querySelector('[type="submit"], [data-add-to-cart]');
      if (btn && (btn.hasAttribute('disabled') ||
        (btn.hasAttribute('data-notification-popup') && form.closest('.variant--soldout')))) return;
      try { sessionStorage.removeItem(form.dataset.mjbAtcKey); } catch (err) {}
      track('atc', { h: form.dataset.mjbAtcHandle || '' });
      assertCartAttribute();
    }, true);
  }

  function pdpAttribution() {
    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;
    var key = REC_KEY_PREFIX + handle;
    // ?mjb=<ts> arrival (open-in-new-tab — the click-time marker lives in the
    // ORIGINATING tab's sessionStorage): write the marker here too, but only
    // when the tag is fresh (<1h old — stale = shared/bookmarked link, not a
    // chat click) and there isn't already an unexpired chat marker (a
    // back-button revisit must not restart the 1h TTL).
    var pm = /[?&]mjb=(\d+)(?:&|$)/.exec(window.location.search);
    if (pm) {
      var tagTs = parseInt(pm[1], 10);
      if (tagTs && Date.now() - tagTs < REC_MAX_AGE_MS) {
        var have = null;
        try { have = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
        var haveFresh = have && have.source === REC_SOURCE && Date.now() - (have.ts || 0) < REC_MAX_AGE_MS;
        if (!haveFresh) {
          try { sessionStorage.setItem(key, JSON.stringify({ source: REC_SOURCE, ts: tagTs })); } catch (e) {}
        }
      }
      // Strip the param either way so it never persists into the address bar,
      // browser history, or copied links (keeps ?variant= etc. intact).
      try {
        var cleaned = window.location.search.replace(/([?&])mjb=\d+(&|$)/, function (m0, lead, tail) {
          return tail === '&' ? lead : '';
        });
        history.replaceState(history.state, '', window.location.pathname + cleaned + window.location.hash);
      } catch (e) { /* history API unavailable — cosmetic only */ }
    }
    injectChatAttribution(key, handle);
    // Palo Alto re-renders the product form on variant change — and a
    // connected-product option swap REPLACES the whole product-info element
    // AND replaceStates the URL to the NEW product. Re-derive the handle at
    // event time (like the reference receivers do) instead of using the
    // load-time closure, so a swapped-in product B checks marker B, not A.
    document.addEventListener('theme:product-info:loaded', function () {
      var h = handleFromUrl(window.location.pathname);
      if (h) injectChatAttribution(REC_KEY_PREFIX + h, h);
    });
  }

  // ---------- markers ----------
  // Bracket-tolerant (the model occasionally fumbles marker syntax): strips
  // [[CARD:n]] variants with extra/missing brackets, partial tails mid-stream,
  // and leftover bracket debris.
  function stripMarkers(text, partial) {
    var clean = String(text)
      .replace(/\[+\s*TRACK\s*\]+/gi, '')
      .replace(/\[+\s*CARD\s*:?\s*\d*(?:\s*\|\s*[^\]]*?)?\s*\]+/gi, '');
    if (partial) {
      clean = clean.replace(/\[+\s*(C(A(R(D)?)?)?)?:?\s*\d*(?:\s*\|\s*[^\]]*)?\]?$/i, '');
      clean = clean.replace(/\[+\s*(T(R(A(C(K)?)?)?)?)?\s*\]?$/i, '');
    }
    clean = clean.replace(/^[ \t]*[\[\],]+[ \t]*$/gm, '');
    clean = clean.replace(/[ \t]+\n/g, '\n');
    clean = clean.replace(/\n{3,}/g, '\n\n');
    clean = clean.replace(/[\s\[\],]+$/, '');
    if (!partial) {
      // Punctuation debris the model leaves where markers (or fumbled
      // markers) sat mid-sentence: "occasions , ." → "occasions."
      clean = clean.replace(/\s+([.,;:!?])/g, '$1');
      clean = clean.replace(/,+(\s*[.!?])/g, '$1');
    }
    return clean.replace(/\*\*/g, '');
  }
  // [[TRACK]] = the model flagging a where-is-my-order question it can't
  // answer itself; the theme hands over to the scripted lookup flow.
  function hasTrackMarker(text) {
    return /\[+\s*TRACK\s*\]+/i.test(String(text || ''));
  }
  function extractCardNumbers(text) {
    var out = [];
    var seen = {};
    // Optional "|Color" after the number lets the assistant open the card on a
    // specific colorway: [[CARD:1|Navy]]. Color captured up to the closing ].
    var re = /\[+\s*CARD\s*:?\s*(\d+)(?:\s*\|\s*([^\]|]+?))?\s*\]+/gi;
    var m;
    while ((m = re.exec(text)) !== null) {
      var n = parseInt(m[1], 10);
      if (n && !seen[n]) { seen[n] = 1; out.push({ n: n, color: (m[2] || '').trim() }); }
      if (out.length >= 3) break;
    }
    return out;
  }

  // Normalize a color label so a marker's color matches a swatch's name
  // ("Royal-Blue" / "royal blue" → "ROYAL BLUE").
  function normColor(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  // Marker fallback: the model sometimes names products but fumbles or skips
  // the [[CARD:n]] markers entirely. A named product should always get its
  // card — match this turn's grounded products by title-word overlap.
  function fuzzyMatchCards(replyText) {
    if (!state.turnProducts.length) return [];
    var reply = String(replyText).toLowerCase();
    var matched = [];
    for (var i = 0; i < state.turnProducts.length && matched.length < 3; i++) {
      var p = state.turnProducts[i];
      if (!p || !p.title) continue;
      var title = p.title.toLowerCase();
      var words = title.split(/[^a-z0-9%]+/).filter(function (w) { return w.length > 2; });
      if (words.length < 3) continue;
      // Signal 1: overall word overlap (model cites most of the title).
      var hit = 0;
      for (var j = 0; j < words.length; j++) {
        if (reply.indexOf(words[j]) !== -1) hit++;
      }
      var overlap = hit / words.length >= 0.6;
      // Signal 2: a DISTINCTIVE consecutive title phrase appears verbatim —
      // catches abbreviated citations like "Drawstring Beach Pants" for a
      // longer catalog title. Bigrams shared by 2+ of this turn's products
      // ("long sleeve", "french cuff") prove nothing and are ignored.
      var phrase = false;
      var bgs = titleBigrams(p.title);
      for (var k = 0; k < bgs.length && !phrase; k++) {
        if (bigramOwners(bgs[k]) === 1 && reply.indexOf(bgs[k]) !== -1) phrase = true;
      }
      if (overlap || phrase) matched.push(p.n);
    }
    return matched;

    function titleBigrams(t) {
      var raw = String(t).toLowerCase().split(/\s+/);
      var out = [];
      for (var a = 0; a < raw.length - 1; a++) {
        var bg = raw[a] + ' ' + raw[a + 1];
        if (bg.length >= 11) out.push(bg);
      }
      return out;
    }
    function bigramOwners(bg) {
      var owners = 0;
      for (var b = 0; b < state.turnProducts.length; b++) {
        var tp = state.turnProducts[b];
        if (tp && tp.title && titleBigrams(tp.title).indexOf(bg) !== -1) owners++;
      }
      return owners;
    }
  }

  // ---------- DOM ----------
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  var root, launcher, panel, messagesEl, inputEl, sendBtn, teaserEl, hideBtn, tabEl;
  var titleEl, backBtn, homeEl, listEl, homeChatsBtn, homeCountEl;

  function build() {
    root = el('div', 'mjb-root');
    root.setAttribute('data-mojito-bubble-root', '');

    launcher = el('button', 'mjb-launcher');
    launcher.type = 'button';
    launcher.setAttribute('aria-label', T.open);
    launcher.innerHTML =
      '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>';
    launcher.addEventListener('click', function () { state.open ? closePanel() : openPanel(); });

    panel = el('div', 'mjb-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', T.title);

    panel.setAttribute('data-view', 'home');

    var header = el('div', 'mjb-header');
    var lead = el('div', 'mjb-header__lead');
    backBtn = el('button', 'mjb-header__back');
    backBtn.type = 'button';
    backBtn.setAttribute('aria-label', T.back);
    backBtn.innerHTML = ICONS.back;
    backBtn.addEventListener('click', goBack);
    lead.appendChild(backBtn);
    titleEl = el('div', 'mjb-header__title', T.title);
    lead.appendChild(titleEl);
    header.appendChild(lead);
    var closeBtn = el('button', 'mjb-header__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', T.close);
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closePanel);
    header.appendChild(closeBtn);
    panel.appendChild(header);

    // Three views share the panel: Home (landing), All chats, and the
    // transcript + composer. data-view on the panel picks which one shows.
    homeEl = buildHome();
    panel.appendChild(homeEl);
    listEl = el('div', 'mjb-list');
    panel.appendChild(listEl);

    messagesEl = el('div', 'mjb-messages');
    panel.appendChild(messagesEl);

    var form = el('form', 'mjb-input');
    inputEl = el('input', 'mjb-input__field');
    inputEl.type = 'text';
    inputEl.maxLength = 400;
    inputEl.placeholder = T.placeholder;
    inputEl.setAttribute('aria-label', T.placeholder);
    sendBtn = el('button', 'mjb-input__send');
    sendBtn.type = 'submit';
    sendBtn.setAttribute('aria-label', T.send);
    sendBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"></path></svg>';
    form.appendChild(inputEl);
    form.appendChild(sendBtn);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = inputEl.value.replace(/\s+/g, ' ').trim();
      if (!text || state.busy) return;
      inputEl.value = '';
      sendMessage(text);
    });
    panel.appendChild(form);

    root.appendChild(panel);
    root.appendChild(launcher);

    // Dismiss badge on the launcher's shoulder — a SIBLING of the launcher
    // (buttons can't nest) absolutely positioned over its corner.
    hideBtn = el('button', 'mjb-hide', '×');
    hideBtn.type = 'button';
    hideBtn.setAttribute('aria-label', T.hide);
    hideBtn.addEventListener('click', collapseBubble);
    root.appendChild(hideBtn);

    document.body.appendChild(root);

    // Edge tab shown while collapsed. Lives OUTSIDE the root — a child would
    // ride off-screen with the translated root.
    tabEl = el('button', 'mjb-tab');
    tabEl.type = 'button';
    tabEl.setAttribute('aria-label', T.show);
    tabEl.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="14 6 8 12 14 18"></polyline></svg>';
    tabEl.addEventListener('click', expandBubble);
    document.body.appendChild(tabEl);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) closePanel();
    });
  }

  function openPanel(noFocus) {
    // A keypress can still reach the launcher during the collapse slide's
    // 0.3s visibility delay — never open the panel while collapsed.
    if (root.classList.contains('mjb-root--hidden')) expandBubble();
    state.open = true;
    root.classList.add('mjb-root--open');
    hideTeaser(true);
    // Land on whatever view this tab-session was on: Home on a fresh visit,
    // and a mid-chat page navigation lands back in that chat.
    showView(state.view, false);
    ensureToken();
    saveChat();
    // Restoring across a page navigation must not steal focus (mobile
    // keyboard would pop on every page) — only focus on a real open tap.
    if (!noFocus && state.view === 'chat') setTimeout(function () { try { inputEl.focus(); } catch (e) {} }, 250);
  }
  function closePanel() {
    state.open = false;
    root.classList.remove('mjb-root--open');
    saveChat();
  }

  function addBubble(role, text, skipLog) {
    var b = el('div', 'mjb-msg mjb-msg--' + role, text);
    messagesEl.appendChild(b);
    scrollDown();
    if (!skipLog && (role === 'user' || role === 'assistant') && text) {
      logPush({ t: role, x: text });
    }
    return b;
  }
  function scrollDown() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function renderChips() {
    var row = el('div', 'mjb-chips');
    T.chips.forEach(function (label) {
      var chip = el('button', 'mjb-chip', label);
      chip.type = 'button';
      chip.addEventListener('click', function () {
        removeChips();
        sendMessage(label);
      });
      row.appendChild(chip);
    });
    messagesEl.appendChild(row);
    scrollDown();
  }
  function removeChips() {
    var rows = messagesEl.querySelectorAll('.mjb-chips');
    for (var i = 0; i < rows.length; i++) rows[i].parentNode.removeChild(rows[i]);
  }

  function renderCards(cards) {
    if (!cards.length || !state.turnProducts.length) return;
    var items = [];
    cards.forEach(function (c) {
      for (var i = 0; i < state.turnProducts.length; i++) {
        var p = state.turnProducts[i];
        if (p && p.n === c.n && p.url && items.length < 3) {
          // Clone before tagging the recommended color (_rc) so it never
          // mutates the shared turnProducts payload that's persisted/restored.
          if (c.color) {
            var pc = {};
            for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) pc[k] = p[k]; }
            pc._rc = c.color;
            items.push(pc);
          } else {
            items.push(p);
          }
          break;
        }
      }
    });
    if (!items.length) return;
    renderCardRow(items);
    track('cards_shown', { h: items.map(function (p) { return handleFromUrl(p.url); }) });
    logPush({ t: 'cards', c: items });
  }

  function renderCardRow(items) {
    // Attribution-tag every card URL once (?mjb=<render timestamp>). Tagging
    // p.url ITSELF — not the anchor — matters: the payload object is what's
    // persisted and restored across pages, and the swatch toggle rebuilds
    // card.href from raw p.url, which would wipe an anchor-only tag. The
    // timestamp (not a bare flag) keeps the param from becoming a shareable
    // attribution trigger: the PDP receiver rejects values older than 1h, so
    // a copied link stops attributing once stale, while the open-in-new-tab
    // case (click follows render within seconds) still works.
    items.forEach(function (p) {
      if (p && p.url && p.url.indexOf('mjb=') === -1) {
        p.url += (p.url.indexOf('?') !== -1 ? '&' : '?') + 'mjb=' + Date.now();
      }
    });
    var row = el('div', 'mjb-cards');
    var added = 0;
    items.forEach(function (p) {
      if (!p || !p.url || added >= 3) return;
      var card = el('a', 'mjb-card');
      card.href = p.url;
      // Card navigation = the attribution moment: write the shared rec-click
      // marker (the PDP receiver turns it into a line-item property) and log
      // the click. Swatch taps stopPropagation, so they never land here.
      var onCardNav = function (e) {
        if (e.type === 'auxclick' && e.button !== 1) return; // middle-click only
        var h = handleFromUrl(card.pathname);
        if (h) {
          try { sessionStorage.setItem(REC_KEY_PREFIX + h, JSON.stringify({ source: REC_SOURCE, ts: Date.now() })); } catch (err) {}
        }
        var vm = String(card.search || '').match(/[?&]variant=(\d+)/);
        track('card_click', { h: h, v: vm ? vm[1] : '' });
        assertCartAttribute();
      };
      card.addEventListener('click', onCardNav);
      card.addEventListener('auxclick', onCardNav);
      var img = null;
      var defaultSrc = '';
      if (p.image) {
        img = document.createElement('img');
        img.className = 'mjb-card__img';
        // NOT lazy: cards are already on-demand (max 3 per turn), and
        // loading="lazy" stalls on images inserted while the panel is
        // display:none (restored transcripts) — they never painted.
        img.decoding = 'async';
        defaultSrc = p.image + (p.image.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
        img.src = defaultSrc;
        img.alt = p.alt || p.title;
        card.appendChild(img);
      }
      card.appendChild(el('div', 'mjb-card__title', p.title));
      if (p.price) card.appendChild(el('div', 'mjb-card__price', p.price));
      if (Array.isArray(p.swatches) && p.swatches.length > 1) {
        // Per-colorway thumbnails; tapping one selects that colorway IN the
        // card (image swap + link re-pointed to ?variant=), tapping it again
        // deselects. The card itself (photo/title/View) then navigates to
        // the selected variant. Spans (not anchors) — nested <a> is invalid.
        // When the assistant recommended a color (_rc), float its swatch to the
        // front so it survives the 5-swatch cap, then auto-open the card on it.
        var sws = p.swatches.slice();
        var recSwatch = null;
        if (p._rc) {
          var want = normColor(p._rc);
          var ri = -1;
          for (var r = 0; r < sws.length; r++) {
            if (sws[r] && normColor(sws[r].c) === want) { ri = r; break; }
          }
          if (ri === -1) {
            // Loose fallback: "navy" ↔ "navy blue", "royal" ↔ "royal blue".
            for (var r2 = 0; r2 < sws.length; r2++) {
              var sc = sws[r2] ? normColor(sws[r2].c) : '';
              if (sc && want && (sc.indexOf(want) !== -1 || want.indexOf(sc) !== -1)) { ri = r2; break; }
            }
          }
          if (ri > 0) { sws.unshift(sws.splice(ri, 1)[0]); }
          if (ri !== -1) recSwatch = sws[0];
        }
        var strip = el('div', 'mjb-card__swatches');
        var recNode = null;
        sws.slice(0, 5).forEach(function (s) {
          if (!s || !s.img || s.img.indexOf('https://') !== 0) return;
          var sw = el('span', 'mjb-card__swatch');
          sw.title = s.c;
          sw.setAttribute('role', 'button');
          sw.setAttribute('tabindex', '0');
          sw.setAttribute('aria-pressed', 'false');
          sw.setAttribute('aria-label', p.title + ' — ' + s.c);
          sw.style.backgroundImage = 'url("' + s.img.replace(/"/g, '') + (s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=120")';
          var toggleSwatch = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var wasOn = sw.classList.contains('mjb-card__swatch--on');
            for (var k = 0; k < strip.childNodes.length; k++) {
              strip.childNodes[k].classList.remove('mjb-card__swatch--on');
              strip.childNodes[k].setAttribute('aria-pressed', 'false');
            }
            if (wasOn) {
              if (img) { img.src = defaultSrc; img.alt = p.alt || p.title; }
              card.href = p.url;
            } else {
              sw.classList.add('mjb-card__swatch--on');
              sw.setAttribute('aria-pressed', 'true');
              if (img) {
                img.src = s.img + (s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
                img.alt = p.title + ' — ' + s.c;
              }
              card.href = s.v ? p.url + (p.url.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + s.v : p.url;
            }
          };
          sw.addEventListener('click', toggleSwatch);
          // role=button promises keyboard operability: Enter (13) / Space (32).
          sw.addEventListener('keydown', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) toggleSwatch(e);
          });
          strip.appendChild(sw);
          if (recSwatch && s === recSwatch) recNode = { sw: sw, s: s };
        });
        if (strip.childNodes.length > 1) {
          card.appendChild(strip);
          // Pre-select the recommended colorway (image swap + variant link), as
          // if its swatch had been tapped — only once the strip actually drew.
          if (recNode && img) {
            recNode.sw.classList.add('mjb-card__swatch--on');
            recNode.sw.setAttribute('aria-pressed', 'true');
            img.src = recNode.s.img + (recNode.s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
            img.alt = p.title + ' — ' + recNode.s.c;
            card.href = recNode.s.v ? p.url + (p.url.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + recNode.s.v : p.url;
          }
        }
      } else if (p.colors && p.colors > 1) {
        card.appendChild(el('div', 'mjb-card__colors', p.colors + (isES ? ' colores' : ' colors')));
      }
      card.appendChild(el('div', 'mjb-card__cta', T.view + ' →'));
      row.appendChild(card);
      added++;
    });
    if (added) {
      messagesEl.appendChild(row);
      scrollDown();
    }
  }

  function showTyping() {
    var t = el('div', 'mjb-msg mjb-msg--assistant mjb-typing');
    t.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(t);
    scrollDown();
    return t;
  }

  // ---------- chat ----------
  // opts.force  — skip the tracking-intent intercept ("Something else")
  // opts.noEcho — the customer's bubble is already on screen
  function sendMessage(text, isRetry, opts) {
    // A where-is-my-order question gets the scripted lookup flow instead of
    // a model turn: no wallet cost, nothing to hallucinate about an order.
    if (!isRetry && !(opts && opts.force) && TRACK_INTENT_RX.test(text)) {
      removeChips();
      ensureChat(text);
      addBubble('user', text);
      startTrackChoice(text, false);
      return;
    }
    setBusy(true);
    removeChips();
    if (!isRetry) {
      ensureChat(text);
      if (!(opts && opts.noEcho)) addBubble('user', text);
    }
    // The reply belongs to THIS chat's log even if the customer opens
    // another chat before it lands — paint only while it is still on screen.
    var logRef = state.log;
    var typing = showTyping();

    ensureToken().then(function (ok) {
      if (!ok) {
        typing.parentNode && typing.parentNode.removeChild(typing);
        if (state.log === logRef) addBubble('assistant', T.error);
        setBusy(false);
        return;
      }
      markEngaged();
      fetch(API + '/api/bubble-chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: state.token,
          message: text,
          history: state.history.slice(-12),
          trk: 1, // this client renders the [[TRACK]] marker
          // Transcript metadata (2026-09-15): the worker stores each turn for
          // the merchant's Conversations view — which of this tab's chats it
          // belongs to, the UI language, and the page the shopper was on.
          cid: state.chat ? state.chat.id : '',
          lang: isES ? 'es' : 'en',
          p: String(window.location.pathname).slice(0, 200)
        })
      }).then(function (res) {
        if (res.status === 401 && !isRetry) {
          // Token stale — mint once and retry once. If THIS attempt's
          // markEngaged rode the rejected token, its 'engaged' beacon was
          // dropped server-side too — clear the one-shot flag so the retry's
          // markEngaged re-fires it with the fresh token. (Only when the
          // beacon went out on the exact token that just failed; an engaged
          // event delivered earlier on a good token must not double-fire.)
          if (engagedSentToken && engagedSentToken === state.token) {
            try { sessionStorage.removeItem('mjbEngaged'); } catch (e) {}
            engagedSentToken = null;
          }
          typing.parentNode && typing.parentNode.removeChild(typing);
          state.token = null;
          return mintToken().then(function (minted) {
            setBusy(false);
            if (minted) sendMessage(text, true, opts);
            else if (state.log === logRef) addBubble('assistant', T.expired);
          });
        }
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (d) {
            typing.parentNode && typing.parentNode.removeChild(typing);
            if (state.log === logRef) addBubble('assistant', (d && d.message) || T.error);
            setBusy(false);
          });
        }
        return streamReply(res, typing, logRef, text).then(function () { setBusy(false); });
      }).catch(function () {
        typing.parentNode && typing.parentNode.removeChild(typing);
        if (state.log === logRef) addBubble('assistant', T.error);
        setBusy(false);
      });
      // Only on the first attempt — the 401 re-mint retry re-enters
      // sendMessage and would double-log the same user turn.
      if (!isRetry) {
        state.history.push({ role: 'user', content: text });
        if (state.history.length > 20) state.history = state.history.slice(-20);
      }
    });
  }

  function streamReply(res, typing, logRef, userText) {
    state.turnProducts = [];
    var reader = res.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    var fullText = '';
    var bubble = null;

    // Watchdog: a black-holed upstream stream would otherwise pend read()
    // forever and leave the input dead behind the busy flag. Cancelling the
    // reader resolves the pending read as done → finish() runs with whatever
    // text arrived (or the soft error if none did).
    var watchdog = null;
    function armWatchdog() {
      if (watchdog) clearTimeout(watchdog);
      watchdog = setTimeout(function () {
        try { reader.cancel(); } catch (e) {}
      }, 60000);
    }
    armWatchdog();

    function handleLine(line) {
      line = line.replace(/\r$/, '');
      if (line.indexOf('data: ') !== 0) return;
      var payload = line.slice(6);
      if (payload === '[DONE]') return;
      var d;
      try { d = JSON.parse(payload); } catch (e) { return; }
      if (d && d.mojito_products) {
        state.turnProducts = d.mojito_products;
        return;
      }
      var tok = d && d.choices && d.choices[0] && d.choices[0].delta && d.choices[0].delta.content;
      if (tok) {
        fullText += tok;
        if (!bubble) {
          if (typing.parentNode) typing.parentNode.removeChild(typing);
          // Paint only into the chat this reply belongs to — a detached node
          // absorbs the stream if the customer has moved to another chat.
          bubble = state.log === logRef ? addBubble('assistant', '') : el('div');
        }
        bubble.textContent = stripMarkers(fullText, true);
        if (state.log === logRef) scrollDown();
      }
    }

    function pump() {
      return reader.read().then(function (result) {
        if (result.done) {
          if (watchdog) clearTimeout(watchdog);
          buffer.split('\n').forEach(handleLine);
          finish();
          return;
        }
        armWatchdog();
        buffer += decoder.decode(result.value, { stream: true });
        var idx;
        while ((idx = buffer.indexOf('\n')) !== -1) {
          handleLine(buffer.slice(0, idx));
          buffer = buffer.slice(idx + 1);
        }
        return pump();
      });
    }

    function finish() {
      var live = state.log === logRef;
      var clean = stripMarkers(fullText, false);
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      if (!clean && !bubble) {
        // Nothing streamed — show a soft error rather than an empty bubble.
        if (live) addBubble('assistant', T.error);
        return;
      }
      if (bubble) {
        if (clean) bubble.textContent = clean;
        else if (bubble.parentNode) bubble.parentNode.removeChild(bubble);
      } else if (clean && live) {
        addBubble('assistant', clean, true); // logged below with the stream path
      }
      if (clean) {
        if (live) state.history.push({ role: 'assistant', content: clean });
        // The streaming bubble was created empty (unlogged) — log the final text.
        logPushTo(logRef, { t: 'assistant', x: clean });
      }
      if (!live) return; // moved to another chat mid-stream: logged, not painted
      var cards = extractCardNumbers(fullText);
      if (!cards.length && clean) cards = fuzzyMatchCards(clean).map(function (n) { return { n: n, color: '' }; });
      renderCards(cards);
      // The model flagged a tracking question it can't answer itself —
      // hand over to the scripted lookup right under its reply.
      if (hasTrackMarker(fullText)) startTrackChoice(userText, true);
    }

    return pump().catch(function () {
      if (watchdog) clearTimeout(watchdog);
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      if (!bubble && state.log === logRef) addBubble('assistant', T.error);
    });
  }

  // ---------- icons (inline SVG, stroke style of the launcher) ----------
  var ICONS = {
    back: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"></path></svg>',
    chevron: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg>',
    external: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"></path><path d="M8 7h9v9"></path></svg>',
    chat: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>',
    search: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg>',
    pkg: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><path d="M3.3 7L12 12l8.7-5"></path><path d="M12 22V12"></path></svg>',
    truck: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h14v12H1z"></path><path d="M15 9h4l4 4v3h-8z"></path><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
    ret: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14L4 9l5-5"></path><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg>',
    user: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>',
    plus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>',
    trash: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"></path><path d="M8 6V4h8v2"></path><path d="M19 6l-1 14H6L5 6"></path><path d="M10 11v6M14 11v6"></path></svg>',
    lock: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>',
    alert: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 8v4"></path><path d="M12 16h.01"></path></svg>',
    refresh: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 4v6h-6"></path><path d="M20.5 15a8.5 8.5 0 1 1-2-9.2L21 10"></path></svg>',
    mail: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M3 7l9 6 9-6"></path></svg>'
  };
  function icon(name, cls) {
    var s = el('span', 'mjb-ico' + (cls ? ' ' + cls : ''));
    s.innerHTML = ICONS[name] || '';
    return s;
  }

  // ---------- views: home / all chats / chat ----------
  function showView(v, remember) {
    if (v !== 'list' && v !== 'chat') v = 'home';
    if (v === 'chat' && !state.chat && !state.log.length) startDraft();
    if (v !== state.view) state.prevView = state.view;
    state.view = v;
    panel.setAttribute('data-view', v);
    titleEl.textContent = v === 'list' ? T.allChats : T.title;
    if (v === 'home') refreshHome();
    if (v === 'list') renderList();
    if (v === 'chat') scrollDown();
    if (remember !== false) saveChat();
  }
  function goBack() {
    if (state.busy) return;
    showView(state.view === 'chat' && state.prevView === 'list' ? 'list' : 'home');
  }
  // The transcript: the active chat, or the draft (greeting + chips).
  function enterChat() {
    showView('chat');
    setTimeout(function () { try { inputEl.focus(); } catch (e) {} }, 250);
  }
  function startNewChat() {
    if (state.busy) return;
    startDraft();
    enterChat();
  }
  function openChat(id) {
    var chat = chatById(id);
    if (!chat || state.busy) return;
    activateChat(chat, false);
    showView('chat');
  }
  function deleteChat(id) {
    for (var i = 0; i < state.chats.length; i++) {
      if (state.chats[i].id === id) { state.chats.splice(i, 1); break; }
    }
    if (state.chat && state.chat.id === id) {
      state.chat = null;
      state.log = [];
      state.history = [];
      clearMessages();
    }
    saveChat();
    if (state.chats.length) renderList(); else showView('home');
  }
  // While a reply streams the back button is inert (CSS dims it) so a
  // half-painted answer can't be walked away from by accident.
  function setBusy(on) {
    state.busy = on;
    if (on) panel.classList.add('mjb-panel--busy'); else panel.classList.remove('mjb-panel--busy');
  }

  function buildHome() {
    var home = el('div', 'mjb-home');
    home.appendChild(el('div', 'mjb-home__hi', T.homeHi));
    home.appendChild(el('div', 'mjb-home__sub', T.homeSub));
    homeChatsBtn = el('button', 'mjb-row mjb-row--chats');
    homeChatsBtn.type = 'button';
    homeChatsBtn.appendChild(icon('chat', 'mjb-row__icon'));
    homeChatsBtn.appendChild(el('span', 'mjb-row__label', T.seeChats));
    homeCountEl = el('span', 'mjb-row__count', '');
    homeChatsBtn.appendChild(homeCountEl);
    homeChatsBtn.appendChild(icon('chevron', 'mjb-row__chev'));
    homeChatsBtn.addEventListener('click', function () { track('home_action', { a: 'chats' }); showView('list'); });
    home.appendChild(homeChatsBtn);
    var group = el('div', 'mjb-group');
    group.appendChild(homeRow('search', T.chips[0], function () { homeAsk('find', T.chips[0]); }));
    group.appendChild(homeRow('pkg', T.track, function () { track('home_action', { a: 'track' }); startTrack(); }));
    group.appendChild(homeRow('truck', T.chips[1], function () { homeAsk('shipping', T.chips[1]); }));
    // Returns & exchanges is the portal page's job — a real link, same tab.
    group.appendChild(homeRow('ret', T.chips[2], function () { track('home_action', { a: 'returns' }); }, PORTAL_URL));
    home.appendChild(group);
    home.appendChild(el('div', 'mjb-home__spacer'));
    home.appendChild(primaryButton(function () { track('home_action', { a: 'new' }); startNewChat(); }));
    home.appendChild(el('div', 'mjb-privacy', T.privacy));
    return home;
  }
  // A Home quick action = a fresh chat with that starter as its first message.
  function homeAsk(key, text) {
    if (state.busy) return;
    track('home_action', { a: key });
    startDraft();
    showView('chat');
    sendMessage(text);
  }
  function homeRow(ic, label, onClick, href) {
    var row = el(href ? 'a' : 'button', 'mjb-row');
    if (href) row.href = href; else row.type = 'button';
    row.appendChild(icon(ic, 'mjb-row__icon'));
    row.appendChild(el('span', 'mjb-row__label', label));
    row.appendChild(icon(href ? 'external' : 'chevron', 'mjb-row__chev'));
    if (onClick) row.addEventListener('click', onClick);
    return row;
  }
  function primaryButton(onClick) {
    var b = el('button', 'mjb-primary');
    b.type = 'button';
    b.appendChild(icon('plus', 'mjb-primary__icon'));
    b.appendChild(el('span', null, T.newChat));
    b.addEventListener('click', onClick);
    return b;
  }
  function refreshHome() {
    var n = state.chats.length;
    homeCountEl.textContent = n ? String(n) : '';
    homeChatsBtn.style.display = n ? '' : 'none';
  }

  function renderList() {
    while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
    var chats = state.chats.slice().sort(function (a, b) { return b.updated - a.updated; });
    var card = el('div', 'mjb-list__card');
    chats.forEach(function (c) { card.appendChild(listRow(c)); });
    listEl.appendChild(card);
    listEl.appendChild(el('div', 'mjb-home__spacer'));
    listEl.appendChild(primaryButton(startNewChat));
    listEl.appendChild(el('div', 'mjb-privacy', T.privacy));
  }
  function listRow(c) {
    var row = el('div', 'mjb-list__row');
    var open = el('button', 'mjb-list__open');
    open.type = 'button';
    open.appendChild(el('div', 'mjb-list__title', c.title));
    open.appendChild(el('div', 'mjb-list__preview', previewOf(c)));
    open.addEventListener('click', function () { openChat(c.id); });
    row.appendChild(open);
    row.appendChild(el('div', 'mjb-list__time', relTime(c.updated)));
    // Delete is two taps: the first arms the button ("Delete?"), the second
    // deletes; it disarms itself after a few seconds.
    var del = el('button', 'mjb-list__del');
    del.type = 'button';
    del.setAttribute('aria-label', T.deleteChat);
    del.appendChild(icon('trash', 'mjb-list__del-icon'));
    del.appendChild(el('span', 'mjb-list__del-label', T.deleteConfirm));
    var armed = false;
    del.addEventListener('click', function () {
      if (armed) { deleteChat(c.id); return; }
      armed = true;
      del.classList.add('mjb-list__del--armed');
      setTimeout(function () { armed = false; del.classList.remove('mjb-list__del--armed'); }, 4000);
    });
    row.appendChild(del);
    return row;
  }
  function previewOf(c) {
    var log = c.log;
    for (var i = log.length - 1; i >= 0; i--) {
      var e = log[i];
      if (!e) continue;
      if ((e.t === 'user' || e.t === 'assistant') && typeof e.x === 'string' && e.x) {
        return e.x.length > 90 ? e.x.slice(0, 87) + '…' : e.x;
      }
      if (e.t === 'cards') return T.prevCards;
      if (e.t === 'track_result' && e.r) return statusCopy(e.r, packagesOf(e.r)[0] || null).title;
      if (e.t === 'track_form' || e.t === 'track_choice') return T.prevTrack;
    }
    return '';
  }
  function relTime(ts) {
    var d = Math.max(0, Date.now() - (+ts || 0));
    if (d < 60000) return T.justNow;
    if (d < 3600000) return Math.floor(d / 60000) + T.minAgo;
    if (d < 86400000) return Math.floor(d / 3600000) + T.hrAgo;
    return Math.floor(d / 86400000) + T.dayAgo;
  }

  // ---------- track a package ----------
  // A scripted flow, not a model turn: the choice step, the order form and
  // the package card are all built here. The worker verifies the order the
  // way the returns portal does (order number + checkout email or ZIP) and
  // returns delivery status only. The email is held in memory for Refresh
  // and never written to storage.
  var PORTAL_URL = '/pages/returns-exchanges';
  var ACCOUNT_URL = script.getAttribute('data-account-url') || '/account';
  var SIGNED_IN = script.getAttribute('data-signed-in') === '1';
  var AMAZON_URL = 'https://www.amazon.com/your-orders/orders';
  var SUPPORT_EMAIL = 'customer.service@mojitocollection.com';
  var TRACK_INTENT_RX = /(\btrack(?:ing)?\b[^.?!]*\b(?:order|package|parcel|shipment|delivery|it)\b|\b(?:order|package|parcel|shipment)\b[^.?!]*\btrack|\bwhere(?:'?s|\s+is|\s+are)?\s+(?:my|the|our)\s+(?:order|package|parcel|shipment|delivery|stuff)\b|\b(?:order|delivery|shipping|shipment)\s+status\b|\bhas(?:n't| not)?\s+(?:it|my order|my package|my stuff)\s+(?:shipped|arrived|come|left|been shipped)\b|\bwhen\s+(?:will|does|is)\s+(?:it|my order|my package)\s+(?:arrive|arriving|ship|get here|come)\b|\bdid my (?:order|package) ship\b|\brastre|\bd[oó]nde\s+(?:est[aá]|anda|va)\s+mi\s+(?:pedido|paquete|orden|env[ií]o)\b|\bestado\s+de\s+mi\s+(?:pedido|orden|env[ií]o)\b|\bseguimiento\b|\bya\s+(?:sali[oó]|se\s+envi[oó])\s+mi\s+(?:pedido|paquete)\b)/i;
  var AMAZON_ORDER_RX = /^\d{3}-\d{7}-\d{7}$/;
  var ORDER_RX = /^#?\s*(?:MC)?\s*\d{1,10}$/i;
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var ZIP_RX = /^\d{5}(?:-\d{4})?$/;
  var LOCALE = isES ? 'es' : 'en-US';

  function normalizeOrder(s) {
    s = String(s || '').replace(/[#\s]/g, '').toUpperCase();
    if (/^\d+$/.test(s)) s = 'MC' + s;
    return s;
  }

  // Home → Track a package. Once a visitor has tracked in this session the
  // choice step is skipped: straight to the form with the order prefilled,
  // and a small "see all my orders" link keeps the account path one tap away.
  function startTrack() {
    if (state.busy) return;
    var reuse = state.chat && state.chat.title === T.track;
    if (!reuse) {
      // A tracking chat opens on its own intro, not the shopping greeting:
      // create it empty BEFORE showing the transcript so no draft greeting
      // gets painted first.
      state.chat = null; state.log = []; state.history = []; clearMessages();
      ensureChat(T.track);
    }
    showView('chat');
    removeChips();
    if (state.trackPref) startTrackForm(state.lastOrder, true);
    else startTrackChoice('', false);
  }
  function startTrackChoice(q, skipIntro) {
    ensureChat(q || T.track);
    if (!skipIntro) addBubble('assistant', T.trackIntro);
    var entry = { t: 'track_choice', q: q || '' };
    logPush(entry);
    renderTrackChoice(entry);
    scrollDown();
  }
  function renderTrackChoice(entry) {
    var wrap = el('div', 'mjb-flow');
    var here = actionCard('pkg', T.trackHere, SIGNED_IN ? T.trackHereSubIn : T.trackHereSub, !SIGNED_IN, '');
    var acct = actionCard('user', SIGNED_IN ? T.acctIn : T.acctOut, SIGNED_IN ? T.acctInSub : T.acctOutSub, SIGNED_IN, ACCOUNT_URL);
    here.addEventListener('click', function () {
      if (state.busy) return;
      track('track_choice', { a: 'here' });
      dropEntry(entry, wrap);
      addBubble('user', T.trackHere);
      startTrackForm('', false);
    });
    acct.addEventListener('click', function () { track('track_choice', { a: 'account' }); });
    // Signed-in visitors get the one-tap account path first.
    if (SIGNED_IN) { wrap.appendChild(acct); wrap.appendChild(here); } else { wrap.appendChild(here); wrap.appendChild(acct); }
    wrap.appendChild(el('div', 'mjb-flow__hint', T.orderHint));
    if (entry.q) {
      // A typed question that only looked like tracking can still go to the AI.
      var chips = el('div', 'mjb-chips');
      chips.appendChild(chipBtn(T.somethingElse, function () {
        if (state.busy) return;
        dropEntry(entry, wrap);
        sendMessage(entry.q, false, { force: true, noEcho: true });
      }));
      wrap.appendChild(chips);
    }
    messagesEl.appendChild(wrap);
  }
  function actionCard(ic, title, sub, primary, href) {
    var card = el(href ? 'a' : 'button', 'mjb-action' + (primary ? ' mjb-action--primary' : ''));
    if (href) card.href = href; else card.type = 'button';
    card.appendChild(icon(ic, 'mjb-action__icon'));
    var txt = el('div', 'mjb-action__text');
    txt.appendChild(el('div', 'mjb-action__title', title));
    txt.appendChild(el('div', 'mjb-action__sub', sub));
    card.appendChild(txt);
    card.appendChild(icon(href ? 'external' : 'chevron', 'mjb-action__chev'));
    return card;
  }
  function chipBtn(label, onClick) {
    var chip = el('button', 'mjb-chip', label);
    chip.type = 'button';
    chip.addEventListener('click', onClick);
    return chip;
  }

  function startTrackForm(order, withAcct) {
    var entry = { t: 'track_form', o: order || '', a: withAcct ? 1 : 0 };
    addBubble('assistant', T.formIntro);
    logPush(entry);
    renderTrackForm(entry, !!withAcct);
    scrollDown();
  }
  function field(type, ph, value) {
    var i = el('input', 'mjb-field');
    i.type = type;
    i.placeholder = ph;
    i.setAttribute('aria-label', ph);
    i.value = value || '';
    return i;
  }
  function renderTrackForm(entry, withAcct) {
    var form = el('form', 'mjb-form');
    form.setAttribute('novalidate', '');
    var byZip = false;
    var noticeKind = null;
    form.appendChild(el('div', 'mjb-form__label', T.fOrder));
    var orderIn = field('text', T.fOrderPh, entry.o || '');
    orderIn.setAttribute('autocomplete', 'off');
    orderIn.maxLength = 24;
    form.appendChild(orderIn);
    var vrow = el('div', 'mjb-form__row');
    var vlabel = el('div', 'mjb-form__label', T.fEmail);
    var toggle = el('button', 'mjb-form__toggle', T.useZip);
    toggle.type = 'button';
    vrow.appendChild(vlabel);
    vrow.appendChild(toggle);
    form.appendChild(vrow);
    var verIn = field('email', T.fEmailPh, '');
    verIn.setAttribute('autocomplete', 'email');
    verIn.setAttribute('inputmode', 'email');
    verIn.maxLength = 100;
    form.appendChild(verIn);
    var notice = el('div', 'mjb-form__notice');
    notice.style.display = 'none';
    form.appendChild(notice);
    var btn = el('button', 'mjb-form__submit', T.find);
    btn.type = 'submit';
    btn.disabled = true;
    form.appendChild(btn);
    var note = el('div', 'mjb-form__note');
    note.appendChild(icon('lock', null));
    note.appendChild(el('span', null, T.formNote));
    form.appendChild(note);
    var acct = el('a', 'mjb-form__acct');
    acct.href = ACCOUNT_URL;
    acct.appendChild(el('span', null, T.acctInstead));
    acct.appendChild(icon('external', null));
    if (!withAcct) acct.style.display = 'none';
    form.appendChild(acct);

    function showNotice(kind, text) {
      noticeKind = kind;
      while (notice.firstChild) notice.removeChild(notice.firstChild);
      notice.className = 'mjb-form__notice' + (kind === 'error' ? ' mjb-form__notice--error' : '');
      if (!kind) { notice.style.display = 'none'; return; }
      notice.appendChild(icon('alert', null));
      var body = el('div', 'mjb-form__notice-body');
      body.appendChild(el('div', null, text));
      if (kind === 'amazon') {
        var a = el('a', 'mjb-form__notice-link');
        a.href = AMAZON_URL;
        a.target = '_blank';
        a.rel = 'noopener';
        a.appendChild(el('span', null, T.amazonLink));
        a.appendChild(icon('external', null));
        body.appendChild(a);
      }
      notice.appendChild(body);
      notice.style.display = '';
    }
    function validate() {
      var o = orderIn.value.trim();
      var v = verIn.value.trim();
      var amazon = AMAZON_ORDER_RX.test(o);
      if (amazon) { if (noticeKind !== 'amazon') showNotice('amazon', T.amazon); }
      else if (noticeKind === 'amazon') showNotice(null);
      btn.disabled = amazon || !ORDER_RX.test(o) || !(byZip ? ZIP_RX.test(v) : EMAIL_RX.test(v));
    }
    function onInput() {
      if (noticeKind === 'error') { showNotice(null); btn.textContent = T.find; }
      validate();
    }
    toggle.addEventListener('click', function () {
      byZip = !byZip;
      vlabel.textContent = byZip ? T.fZip : T.fEmail;
      toggle.textContent = byZip ? T.useEmail : T.useZip;
      verIn.type = byZip ? 'text' : 'email';
      verIn.placeholder = byZip ? T.fZipPh : T.fEmailPh;
      verIn.setAttribute('aria-label', verIn.placeholder);
      verIn.setAttribute('inputmode', byZip ? 'numeric' : 'email');
      verIn.setAttribute('autocomplete', byZip ? 'postal-code' : 'email');
      verIn.value = '';
      onInput();
    });
    orderIn.addEventListener('input', onInput);
    verIn.addEventListener('input', onInput);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || state.busy) return;
      var creds = { order: normalizeOrder(orderIn.value), email: byZip ? '' : verIn.value.trim(), zip: byZip ? verIn.value.trim() : '' };
      entry.o = orderIn.value.trim();
      saveChat();
      submitTrack(entry, form, creds, function (msg) {
        showNotice('error', msg);
        acct.style.display = '';
        btn.textContent = T.tryAgain;
        btn.disabled = false;
      });
    });
    validate();
    messagesEl.appendChild(form);
    return form;
  }

  function submitTrack(entry, form, creds, onError) {
    var btn = form.querySelector('.mjb-form__submit');
    setBusy(true);
    btn.disabled = true;
    btn.textContent = T.finding;
    var typing = showTyping();
    var logRef = state.log;
    ensureToken().then(function (ok) {
      if (!ok) throw new Error('token');
      markEngaged();
      return trackFetch(creds, false);
    }).then(function (res) {
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      setBusy(false);
      var d = res.d || {};
      if (res.ok && d.success && d.result) {
        var r = d.result;
        var name = (r.order && r.order.name) || creds.order;
        state.trackCreds = creds;
        state.trackPref = true;
        state.lastOrder = name;
        track('track_ok', { s: firstStatus(r) });
        var re = { t: 'track_result', r: r };
        if (state.log !== logRef) {
          // Customer moved to another chat mid-lookup: record it, don't paint it.
          var i = logRef.indexOf(entry);
          if (i !== -1) logRef.splice(i, 1);
          logPushTo(logRef, { t: 'assistant', x: T.found.replace('{o}', name) });
          logPushTo(logRef, re);
          logPushTo(logRef, { t: 'ctx', x: ctxLine(r) });
          return;
        }
        dropEntry(entry, form);
        addBubble('assistant', T.found.replace('{o}', name));
        logPush(re);
        renderTrackResult(re);
        // Let the model see what the customer was shown, so a follow-up like
        // "when will it arrive?" makes sense — never rendered.
        logPush({ t: 'ctx', x: ctxLine(r) });
        state.history = historyFromLog(state.log);
        renderTrackChips(re);
        scrollDown();
        return;
      }
      track('track_miss', { s: d.code || String(res.status) });
      btn.textContent = T.find;
      if (res.status === 404 || d.code === 'not_found') onError(creds.zip ? T.notFoundZip : T.notFoundEmail);
      else if (res.status === 429) onError(T.tooMany);
      else onError(d.message || T.error);
    }).catch(function () {
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      setBusy(false);
      btn.textContent = T.find;
      onError(T.error);
    });
  }
  function trackFetch(creds, isRetry) {
    var body = { token: state.token, order: creds.order };
    if (creds.zip) body.zip = creds.zip; else body.email = creds.email;
    return fetch(API + '/api/bubble-track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status === 401 && !isRetry) {
        state.token = null;
        return mintToken().then(function (minted) {
          if (!minted) return { ok: false, status: 401, d: { message: T.expired } };
          return trackFetch(creds, true);
        });
      }
      return res.json().catch(function () { return {}; }).then(function (d) {
        return { ok: res.ok, status: res.status, d: d };
      });
    });
  }

  function packagesOf(r) { return r && Array.isArray(r.packages) ? r.packages : []; }
  function firstStatus(r) {
    var p = packagesOf(r);
    if (p.length) return String(p[0].status || '');
    return r.order && r.order.cancelled ? 'cancelled' : 'unfulfilled';
  }
  function ctxLine(r) {
    var pk = packagesOf(r);
    var name = r.order && r.order.name ? r.order.name : '';
    var bits = pk.length
      ? pk.map(function (p, i) { return (pk.length > 1 ? 'package ' + (i + 1) + ': ' : '') + statusCopy(r, p).title; })
      : [statusCopy(r, null).title];
    return '(Shared the package tracking card for order ' + name + ' — ' + bits.join('; ') + '. The customer can see it; do not ask for order details.)';
  }
  function joinBits(parts) {
    return parts.filter(function (x) { return !!x; }).join(' · ');
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try { return d.toLocaleDateString(LOCALE, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); }
  }
  function fmtWhen(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var now = new Date();
    var sameDay = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
    if (!sameDay) return fmtDate(iso);
    try { return d.toLocaleTimeString(LOCALE, { hour: 'numeric', minute: '2-digit' }); } catch (e) { return fmtDate(iso); }
  }
  function agoLower(ts) {
    var d = Math.max(0, Date.now() - (+ts || 0));
    if (d < 60000) return T.justNowLower;
    if (d < 3600000) return T.agoMin.replace('{n}', Math.floor(d / 60000));
    return T.agoHr.replace('{n}', Math.floor(d / 3600000));
  }
  // Headline, subline, progress position and follow-up copy for one package
  // (or the order itself when nothing has shipped).
  function statusCopy(r, p) {
    var c = { title: '', sub: '', eta: '', extra: '', steps: 1, problem: false };
    var o = r.order || {};
    if (o.cancelled) {
      c.title = T.stCancelled; c.sub = T.orderedOn.replace('{d}', fmtDate(o.createdAt)); c.steps = 0; c.extra = T.stCancelledX;
      return c;
    }
    if (!p) {
      c.title = T.stPreparing; c.sub = T.orderedOn.replace('{d}', fmtDate(o.createdAt)); c.steps = 1; c.extra = T.stPreparingX;
      return c;
    }
    var carrier = p.carrier || '';
    var when = p.updatedAt || p.createdAt || '';
    var ev = p.lastEvent || null;
    var evAt = ev && ev.at ? ev.at : when;
    var where = ev ? joinBits([ev.city, ev.province].map(function (x) { return x || ''; })).replace(' · ', ', ') : '';
    switch (p.status) {
      case 'in_transit':
        c.title = T.stTransit;
        c.sub = joinBits([carrier, ev && ev.message ? ev.message : '', where, fmtWhen(evAt)]);
        c.steps = 2.5;
        break;
      case 'out_for_delivery':
        c.title = T.stOut;
        c.sub = joinBits([carrier, T.lastUpdate.replace('{t}', fmtWhen(evAt)), where]);
        c.steps = 3;
        break;
      case 'delivered':
        c.title = T.stDelivered.replace('{d}', fmtDate(evAt));
        c.sub = joinBits([carrier, ev && ev.message ? ev.message : '']);
        c.steps = 4;
        c.extra = T.stDeliveredX;
        break;
      case 'attempted':
        c.title = T.stAttempted; c.sub = joinBits([carrier, T.stAttemptedS]); c.steps = 3;
        break;
      case 'pickup':
        c.title = T.stPickup; c.sub = joinBits([carrier, T.stPickupS]); c.steps = 3;
        break;
      case 'problem':
        c.title = T.stProblem;
        c.sub = joinBits([T.stProblemS.replace('{c}', carrier || T.carrier), fmtDate(evAt)]);
        c.steps = 3; c.problem = true; c.extra = T.stProblemX;
        break;
      default: // shipped / label created / carrier confirmed
        if (!p.number && !p.url) {
          c.title = T.stShippedS.replace('{d}', fmtDate(p.createdAt || when));
          c.sub = T.stNoTracking;
          c.extra = T.stNoTrackingX;
        } else {
          c.title = T.stShipped;
          c.sub = joinBits([carrier, T.stShippedS.replace('{d}', fmtDate(p.createdAt || when))]);
        }
        c.steps = 2;
    }
    if (p.eta && p.status !== 'delivered') c.eta = T.arrives.replace('{d}', fmtDate(p.eta));
    return c;
  }
  function renderTrackResult(entry) {
    var wrap = buildTrackResult(entry);
    messagesEl.appendChild(wrap);
    return wrap;
  }
  function buildTrackResult(entry) {
    var r = entry.r;
    var wrap = el('div', 'mjb-flow');
    var pk = packagesOf(r);
    if (!pk.length) wrap.appendChild(packageCard(r, null, 0, 0));
    else pk.forEach(function (p, i) { wrap.appendChild(packageCard(r, p, i + 1, pk.length)); });
    var meta = el('div', 'mjb-checked');
    meta.appendChild(el('span', null, T.checked.replace('{t}', agoLower(r.checkedAt))));
    meta.appendChild(el('span', null, '·'));
    var rf = el('button', 'mjb-checked__refresh');
    rf.type = 'button';
    rf.appendChild(icon('refresh', null));
    rf.appendChild(el('span', null, T.refresh));
    rf.addEventListener('click', function () { refreshTrack(entry, wrap); });
    meta.appendChild(rf);
    wrap.appendChild(meta);
    return wrap;
  }
  function packageCard(r, p, n, total) {
    var c = statusCopy(r, p);
    var o = r.order || {};
    var card = el('div', 'mjb-pkg');
    var metaBits = [o.name || ''];
    if (o.itemCount) metaBits.push(o.itemCount === 1 ? T.item1 : T.items.replace('{n}', o.itemCount));
    if (total > 1) metaBits.push(T.pkgOf.replace('{n}', n).replace('{t}', total));
    card.appendChild(el('div', 'mjb-pkg__meta', joinBits(metaBits)));
    var head = el('div', 'mjb-pkg__head');
    head.appendChild(el('span', 'mjb-pkg__dot' + (c.problem ? ' mjb-pkg__dot--problem' : (c.steps <= 1 ? ' mjb-pkg__dot--soft' : ''))));
    head.appendChild(el('div', 'mjb-pkg__title', c.title));
    card.appendChild(head);
    if (c.sub) card.appendChild(el('div', 'mjb-pkg__sub', c.sub));
    if (c.eta) card.appendChild(el('div', 'mjb-pkg__eta', c.eta));
    if (c.steps > 0) card.appendChild(progressEl(c.steps, c.problem));
    if (c.extra) card.appendChild(el('div', 'mjb-pkg__extra', c.extra));
    if (p && (p.number || p.url)) {
      var foot = el('div', 'mjb-pkg__foot');
      var num = el('div', 'mjb-pkg__num');
      num.appendChild(el('div', 'mjb-pkg__numlbl', p.carrier ? T.trackingLbl.replace('{c}', p.carrier) : T.trackingLblGen));
      num.appendChild(el('div', 'mjb-pkg__numval', p.number || ''));
      foot.appendChild(num);
      if (p.url && /^https:\/\//i.test(p.url)) {
        var a = el('a', 'mjb-pkg__link');
        a.href = p.url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.appendChild(el('span', null, p.carrier ? T.trackOn.replace('{c}', p.carrier) : T.trackPkg));
        a.appendChild(icon('external', null));
        foot.appendChild(a);
      }
      card.appendChild(foot);
    }
    return card;
  }
  // Four-step progress: steps 1..4 filled up to the current one (2.5 = in
  // transit, between Shipped and Out for delivery).
  function progressEl(steps, problem) {
    var bar = el('div', 'mjb-track');
    bar.appendChild(el('div', 'mjb-track__line'));
    var done = Math.floor(steps);
    if (steps > 1) {
      var fill = el('div', 'mjb-track__fill');
      fill.style.width = ((steps - 1) * 25) + '%';
      bar.appendChild(fill);
    }
    T.steps.forEach(function (label, i) {
      var k = i + 1;
      var cls = 'mjb-track__step';
      if (k < done) cls += ' mjb-track__step--done';
      else if (k === done) cls += problem ? ' mjb-track__step--problem' : ' mjb-track__step--now';
      var step = el('div', cls);
      step.appendChild(el('div', 'mjb-track__dot'));
      step.appendChild(el('div', 'mjb-track__label', (problem && k === done) ? T.stepProblem : label));
      bar.appendChild(step);
    });
    return bar;
  }
  function renderTrackChips(entry) {
    var r = entry.r;
    var st = firstStatus(r);
    var row = el('div', 'mjb-chips');
    row.appendChild(chipBtn(T.trackAnother, function () {
      if (state.busy) return;
      removeChips();
      addBubble('user', T.trackAnother);
      startTrackForm('', false);
    }));
    var ret = el('a', 'mjb-chip mjb-chip--link', T.returnEx);
    ret.href = PORTAL_URL;
    row.appendChild(ret);
    var problemLabel = st === 'delivered' ? T.notDelivered : (st === 'problem' ? T.contact : T.problem);
    row.appendChild(chipBtn(problemLabel, function () {
      if (state.busy) return;
      removeChips();
      addBubble('user', problemLabel);
      addBubble('assistant', T.problemReply);
      var mail = el('div', 'mjb-chips');
      var a = el('a', 'mjb-chip mjb-chip--link');
      var subject = (r.order && r.order.name ? 'Order ' + r.order.name + ' - ' : '') + problemLabel;
      a.href = 'mailto:' + SUPPORT_EMAIL + '?subject=' + encodeURIComponent(subject);
      a.appendChild(icon('mail', null));
      a.appendChild(el('span', null, T.emailUs));
      mail.appendChild(a);
      messagesEl.appendChild(mail);
      scrollDown();
    }));
    messagesEl.appendChild(row);
    scrollDown();
  }
  function refreshTrack(entry, wrap) {
    if (state.busy) return;
    var creds = state.trackCreds;
    var name = entry.r && entry.r.order ? entry.r.order.name : '';
    if (!creds || normalizeOrder(creds.order) !== normalizeOrder(name)) {
      // The email isn't kept across pages — ask again with the order prefilled.
      removeChips();
      startTrackForm(name, false);
      return;
    }
    setBusy(true);
    var typing = showTyping();
    var logRef = state.log;
    ensureToken().then(function (ok) {
      if (!ok) throw new Error('token');
      return trackFetch(creds, false);
    }).then(function (res) {
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      setBusy(false);
      if (res.ok && res.d && res.d.success && res.d.result) {
        entry.r = res.d.result;
        saveChat();
        if (state.log === logRef && wrap.parentNode) wrap.parentNode.replaceChild(buildTrackResult(entry), wrap);
      } else if (state.log === logRef) {
        addBubble('assistant', (res.d && res.d.message) || T.error);
      }
    }).catch(function () {
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      setBusy(false);
      if (state.log === logRef) addBubble('assistant', T.error);
    });
  }

  // ---------- hide / edge tab ----------
  // Collapsing slides the whole bubble off the right edge and slides in a slim
  // edge tab; expanding reverses it. Persisted per tab-session so the choice
  // sticks across page navigations but resets on a fresh visit. The panel is
  // force-closed BEFORE the root transforms — the mobile panel is
  // position:fixed, and a transformed ancestor would become its containing
  // block and misplace it.
  function collapseBubble(evt) {
    // Arm the slide transitions when there's an argument (see the .mjb-anim
    // comment in the CSS). On the init-restore path restoreChat has already
    // forced a layout (scrollHeight reads), so an armed transition would
    // replay the 0.3s slide-out on every page load instead of restoring
    // already-hidden — that path calls collapseBubble() with no argument.
    // Only a real user DOM event (a click on the hide badge) moves focus to
    // the tab; the auto-tuck intro passes a plain flag so it slides WITHOUT
    // yanking focus or scrolling the page under the visitor.
    var userGesture = evt && typeof evt.type === 'string' && evt.type.length > 0;
    // Preserve tab order: if focus was resting on the launcher/hide badge (a
    // keyboard or SR user), forward it to the tab even on the auto-tuck path —
    // .mjb-root--hidden goes visibility:hidden and would otherwise drop focus
    // to <body>. When nothing here is focused, the auto-tuck stays hands-off.
    var hadFocus = document.activeElement === launcher || document.activeElement === hideBtn;
    if (evt) {
      root.classList.add('mjb-anim');
      tabEl.classList.add('mjb-anim');
    }
    hideTeaser(true);
    if (state.open) closePanel();
    root.classList.add('mjb-root--hidden');
    tabEl.classList.add('mjb-tab--on');
    try { sessionStorage.setItem('mjbCollapsed', '1'); } catch (e) {}
    if (userGesture || hadFocus) { try { tabEl.focus({ preventScroll: true }); } catch (e) {} }
  }
  function expandBubble(evt) {
    root.classList.add('mjb-anim');
    tabEl.classList.add('mjb-anim');
    root.classList.remove('mjb-root--hidden');
    tabEl.classList.remove('mjb-tab--on');
    try { sessionStorage.removeItem('mjbCollapsed'); } catch (e) {}
    if (evt) { try { launcher.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ---------- landing intro ----------
  // First fresh landing of the tab-session: let the launcher sit a moment so
  // the visitor notices it, give it one self-playing "pop" (the hover pose,
  // animated), then slide it to the edge tab so it's out of the way. Runs at
  // most once per session and never over an engaged or already-collapsed
  // state — so a mid-conversation page navigation won't replay it.
  function runLandingIntro() {
    var seen = false;
    try { seen = !!sessionStorage.getItem('mjbIntroDone'); } catch (e) {}
    if (seen) return;
    // Already engaged (panel open, greeted, or restored transcript) or already
    // collapsed earlier this session — nothing to introduce.
    if (state.open || state.chats.length || state.log.length) return;
    if (root.classList.contains('mjb-root--hidden')) return;
    // Claim the one-shot up front: even if the visitor engages mid-intro, the
    // next page in this session must not replay it.
    try { sessionStorage.setItem('mjbIntroDone', '1'); } catch (e) {}

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    // The timer fires unconditionally, so both the delay body and the tuck
    // handler must re-test the FULL engagement guard (not just open/hidden):
    // the visitor can open then close the panel inside the settle+pop window,
    // which leaves open=false and not-hidden but greeted=true / log populated —
    // we must not pop or auto-tuck a bubble they already used.
    function engagedOrGone() {
      return state.open || state.chats.length || state.log.length ||
        root.classList.contains('mjb-root--hidden');
    }

    // Beat 1: settle delay so the page paints and the eye lands on content
    // before the bubble moves in the periphery.
    setTimeout(function () {
      if (engagedOrGone()) return;
      // Reduced motion: skip the pop; tuck quietly (CSS also no-ops the slide).
      if (reduce) { collapseBubble(true); return; }

      var fallback = null;
      var tuck = function (e) {
        // Ignore animationend bubbling from any other animation on the launcher.
        if (e && e.type === 'animationend' && e.animationName &&
            e.animationName.indexOf('mjb-attention') === -1) return;
        launcher.removeEventListener('animationend', tuck);
        if (fallback) { clearTimeout(fallback); fallback = null; }
        launcher.classList.remove('mjb-launcher--attention');
        if (engagedOrGone()) return;
        collapseBubble(true); // animated slide, no focus/scroll (see collapseBubble)
      };
      launcher.addEventListener('animationend', tuck);
      // Fallback if animationend never fires (e.g. the tab was backgrounded so
      // the animation never ran) — a touch longer than the 1.4s keyframe.
      fallback = setTimeout(tuck, 1700);
      launcher.classList.add('mjb-launcher--attention');
    }, 2200);
  }

  // ---------- proactive teaser ----------
  function showTeaser() {
    var done = false;
    try { done = !!sessionStorage.getItem('mjbTeaserDone'); } catch (e) {}
    if (done || state.open || root.classList.contains('mjb-root--hidden')) return;
    teaserEl = el('div', 'mjb-teaser');
    var txt = el('button', 'mjb-teaser__text', T.teaser);
    txt.type = 'button';
    txt.addEventListener('click', function () {
      hideTeaser(true);
      // The teaser promised help finding a piece — land in a chat, not Home.
      openPanel(true);
      enterChat();
    });
    var x = el('button', 'mjb-teaser__close', '×');
    x.type = 'button';
    x.setAttribute('aria-label', T.close);
    x.addEventListener('click', function () { hideTeaser(true); });
    teaserEl.appendChild(txt);
    teaserEl.appendChild(x);
    root.appendChild(teaserEl);
    launcher.classList.add('mjb-launcher--pulse');
    setTimeout(function () { hideTeaser(true); }, 12000);
  }
  function hideTeaser(remember) {
    if (teaserEl && teaserEl.parentNode) teaserEl.parentNode.removeChild(teaserEl);
    teaserEl = null;
    if (launcher) launcher.classList.remove('mjb-launcher--pulse');
    if (remember) { try { sessionStorage.setItem('mjbTeaserDone', '1'); } catch (e) {} }
  }

  // ---------- init ----------
  function init() {
    // Double-render guard: if the snippet ever ends up included twice, only
    // the first instance builds a bubble.
    if (document.querySelector('[data-mojito-bubble-root]')) return;
    loadStoredToken();
    // PDP attribution receiver runs on every product page — it needs no
    // bubble DOM, only the stored token/markers.
    pdpAttribution();
    build();
    restoreChat();
    // Re-apply a collapse from earlier in this session AFTER restoreChat —
    // it force-closes any restored-open panel. Classes land in the same task
    // as build(), before first paint, so there's no slide animation on load.
    var collapsed = false;
    try { collapsed = !!sessionStorage.getItem('mjbCollapsed'); } catch (e) {}
    if (collapsed) collapseBubble();
    // Landing intro (notice-then-tuck) supersedes the proactive teaser on a
    // fresh visit — it self-guards to run at most once and only over an
    // un-engaged, un-collapsed bubble; the teaser then no-ops while hidden.
    runLandingIntro();
    setTimeout(showTeaser, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* MOJITO: scroll-to-top button — keep it clear of the PDP sticky cart-bar.
   Independent of the chat bubble above (its own IIFE) so it runs even when the
   bubble bails. The scroll-top button is a light-DOM theme element pinned
   bottom-right; on product pages the theme's sticky .cart-bar (options + Add to
   Cart) slides up on scroll into the same bottom strip. We lift the button to
   sit just above the bar while it's up — measuring the bar's actual on-screen
   intrusion so it works for the taller mobile bar and the desktop bar alike.
   No .cart-bar on the page (every non-product template) → no-op. */
(function () {
  'use strict';
  var BASE = 18; // resting bottom offset — MUST match .btn--scroll-top in the CSS (margin:0)
  var GAP = 10;  // breathing room between the button and the bar's top edge
  var btn = null, bar = null, boundBar = null, following = 0, followUntil = 0, lastApplied = -1;

  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  // Re-query a cached node once it's gone: a connected/combined-listing option
  // swap (e.g. Big & Tall) REPLACES the product form, detaching the old
  // cart-bar — a stale ref reads a 0-size rect and silently stops lifting. Also
  // move the transitionend listener onto whichever bar is current.
  function resolve() {
    if (!btn || !btn.isConnected) { btn = document.querySelector('.btn--scroll-top'); lastApplied = -1; }
    if (!bar || !bar.isConnected) { bar = document.querySelector('.cart-bar'); }
    if (bar !== boundBar) {
      if (boundBar) boundBar.removeEventListener('transitionend', apply);
      if (bar) bar.addEventListener('transitionend', apply);
      boundBar = bar;
    }
    return btn && bar;
  }
  function apply() {
    if (!resolve()) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = bar.getBoundingClientRect();
    // How far the bar covers up from the viewport bottom (0 when parked below).
    var intrude = Math.max(0, vh - r.top);
    // Continuous: rest at BASE, then track the bar up as soon as intrude+GAP
    // would exceed it — Math.max (not a threshold) avoids a step/pop at the edge.
    var target = (r.height > 0) ? Math.max(BASE, Math.round(intrude + GAP)) : BASE;
    if (target === lastApplied) return; // skip redundant per-frame writes
    // Inline !important outranks the stylesheet !important, so this always wins.
    btn.style.setProperty('bottom', target + 'px', 'important');
    lastApplied = target;
  }
  // rAF follow-loop: track the bar every frame while scrolling AND for a short
  // tail afterward, so a scroll that stops mid-slide keeps following the bar's
  // ~0.3s animation to rest instead of snapping. Self-terminates when idle.
  function tick() {
    apply();
    if (now() < followUntil) following = requestAnimationFrame(tick);
    else following = 0;
  }
  function schedule() {
    followUntil = now() + 420;
    if (!following) following = requestAnimationFrame(tick);
  }
  function start() {
    // .cart-bar exists in the DOM on product pages even while parked off-screen;
    // its absence means a non-product template — nothing to guard against.
    if (!document.querySelector('.cart-bar')) return;
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    // A connected-listing swap replaces the cart-bar node — drop the stale refs
    // and re-sync against the freshly rendered bar.
    document.addEventListener('theme:product-info:loaded', function () { bar = null; btn = null; schedule(); });
    apply();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
